<ngx-gov-co-shd-app-header-auth>
  <div *ngIf="showViewHTMLComponent" shd-container-router-component>
    <div class="container-shd-component-menu-panel-right">
      <div class="row-shd-component-menu-panel-right">
        <div class="col-main-shd-component-menu-panel-right">
          <nav aria-label="breadcrumb-shd-component-menu-panel-right">
            <ol class="breadcrumb-shd-component-menu-panel-right">
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)" class="active">Inicio</a>
              </li>
            </ol>
          </nav>

          <h1 class="page-title-shd-component-menu-panel-right mb-50">Hola, <b> {{this.nameUser}}</b>.</h1>
          <h1 class="page-title-shd-component-menu-panel-right-sub">Declara y paga tu impuesto desde la sección <span>“Mis Impuestos”</span>.</h1>
          <h2 class="page-subtitle-shd-component-menu-panel-right mb-20">Realiza tu trámite en tres pasos simples: liquida, firma y paga desde el módulo correspondiente.</h2>
          <div class="main-container">
            <div class="container-cards">
              <div class="card step-card-info">
                <div class="card-content step-content-info">
                  <div class="step-circle"><span
                    >1</span></div>
                  <h3 class="card-content-step-h3">Liquidar</h3>
                  <p class="card-content-step-p">Usa la calculadora en línea para ingresar tus datos y generar la declaración del impuesto.</p>
                </div>
                <div class="step-container-imagen">
                  <img alt="Liquidar" src="{{urlsPaso.uno}}" class="step-image step-image-1">
                </div>
              </div>
              <div class="card step-card-info">
                <div class="card-content step-content-info">
                  <div class="step-circle"><span
                    >2</span></div>
                  <h3 class="card-content-step-h3">Firmar</h3>
                  <p class="card-content-step-p">Fírmala electrónicamente en la plataforma o sube el archivo ya firmado digitalmente.</p>
                </div>
                <div class="step-container-imagen">
                  <img alt="Firmar" src="{{urlsPaso.dos}}" class="step-image">
                </div>
              </div>
              <div class="card step-card-info">
                <div class="card-content step-content-info">
                  <div class="step-circle"><span
                    >3</span></div>
                  <h3 class="card-content-step-h3">Pagar</h3>
                  <p class="card-content-step-p">Selecciona la declaración pendiente y haz el pago en línea.</p>
                </div>
                <div class="step-container-imagen">
                  <img alt="Pagar" src="{{urlsPaso.tres}}" class="step-image">
                </div>
              </div>
            </div>
          </div>
          <br>
          <br>
          <h2 class="page-subtitle-shd-component-menu-panel-right">Más Información</h2>
          <div class="main-container">
            <div class="container-cards user-cursor">
              <div class="card card-user-cursor" (click)="openWindowTarget(urlPreguntasFrec)" tabindex="0"
                (keydown.enter)="openWindowTarget(urlPreguntasFrec)">
                <div class="card-content">
                  <span class="material-symbols-outlined">find_in_page</span>
                  <h3 class="text-center">Preguntas Frecuentes</h3>
                  <p class="text-center card-content-p-text">Encuentra respuestas rápidas.</p>
                </div>
              </div>

              <div class="card card-user-cursor" (click)="openWindowTarget(urlCalendario)" tabindex="0"
                (keydown.enter)="openWindowTarget(urlCalendario)">
                <div class="card-content">
                  <span class="material-symbols-outlined">event</span>
                  <h3 class="text-center">Calendario Tributario</h3>
                  <p class="text-center card-content-p-text">Revisa fechas clave de pago.</p>
                </div>
              </div>

              <div class="card card-user-cursor" (click)="openWindowTarget(urlRecaudoAno)" tabindex="0"
                (keydown.enter)="openWindowTarget(urlRecaudoAno)">
                <div class="card-content">
                  <span class="material-symbols-outlined">payments</span>
                  <h3 class="text-center">Así vamos en recaudo</h3>
                  <p class="text-center card-content-p-text">Consulta el avance del recaudo.</p>
                </div>
              </div>
              <div class="card card-user-cursor" (click)="openWindowTarget(urlNoticias)" tabindex="0"
                (keydown.enter)="openWindowTarget(urlNoticias)">
                <div class="card-content">
                  <span class="material-symbols-outlined">article</span>
                  <h3 class="text-center">Noticias</h3>
                  <p class="text-center card-content-p-text">Mantente al día con novedades.</p>
                </div>
              </div>
              <div class="card card-user-cursor" (click)="getCerPag()" tabindex="0"
                (keydown.enter)="getCerPag()">
                <div class="card-content">
                  <span class="material-symbols-outlined">archive</span>
                  <h3 class="text-center">Descargar RIT</h3>
                  <p class="text-center card-content-p-text">Obtén tu registro tributario.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-gov-co-shd-app-header-auth>
<span class="material-symbols-outlined hidden-preload-icon">home</span>